export const translations = {
  en: {
    // Common
    'app.name': 'Hospital Booking System',
    'app.tagline': 'Easy Appointment Scheduling',
    'welcome': 'Welcome',
    'logout': 'Logout',
    'cancel': 'Cancel',
    'close': 'Close',
    'confirm': 'Confirm',
    'save': 'Save',
    'delete': 'Delete',
    'edit': 'Edit',
    'create': 'Create',
    'update': 'Update',
    'close': 'Close',
    'loading': 'Loading...',
    
    // Navigation
    'nav.home': 'Home',
    'nav.admin': 'Admin Dashboard',
    'nav.login': 'Login',
    'nav.register': 'Register',
    
    // Dashboard
    'dashboard.title': 'Book Your Appointment',
    'dashboard.subtitle': 'Select a date and time slot that works for you',
    'dashboard.calendar': 'Calendar View',
    'dashboard.slots': 'Available Slots',
    'dashboard.myBookings': 'My Bookings',
    'dashboard.noSlots': 'No available slots for this date',
    'dashboard.noBookings': 'You have no bookings yet',
    'dashboard.selectDate': 'Select Date',
    'dashboard.bookNow': 'Book Now',
    'dashboard.guestNote': 'You can book as a guest, but logging in allows you to manage your bookings.',
    
    // Booking
    'booking.title': 'Book Appointment',
    'booking.subtitle': 'Complete the form below to confirm your booking',
    'booking.date': 'Date',
    'booking.time': 'Time',
    'booking.yourInfo': 'Your Information',
    'booking.fullName': 'Full Name',
    'booking.email': 'Email Address',
    'booking.additionalInfo': 'Additional Information',
    'booking.confirm': 'Confirm Booking',
    'booking.booking': 'Booking...',
    'booking.success': 'Booking confirmed successfully!',
    'booking.successMessage': 'Your appointment has been booked successfully!',
    'booking.cancel': 'Cancel Booking',
    'booking.cancelConfirm': 'Are you sure you want to cancel this booking?',
    'booking.details': 'Booking Details',
    'booking.status': 'Status',
    'booking.status.confirmed': 'Confirmed',
    'booking.status.cancelled': 'Cancelled',
    'booking.status.pending': 'Pending',
    'booking.guest': 'Guest Booking',
    'booking.select': 'Select',
    'booking.loadingFields': 'Loading booking form...',
    'booking.stillLoading': 'Please wait, the booking form is still loading.',
    'booking.fieldsFailed': 'Could not load the booking form. Please refresh and try again.',
    'booking.retry': 'Retry',
    
    // Calendar
    'calendar.goToToday': 'Go to Today',
    'calendar.available': 'Available',
    'calendar.booked': 'Booked',
    
    // Admin
    'admin.title': 'Admin Dashboard',
    'admin.subtitle': 'Manage slots, booking fields, and view reservations',
    'admin.manageSlots': 'Manage Slots',
    'admin.bookingFields': 'Booking Fields',
    'admin.viewBookings': 'View Bookings',
    'admin.createSlot': 'Create Single Slot',
    'admin.bulkCreate': 'Bulk Create Slots',
    'admin.allSlots': 'All Slots',
    'admin.date': 'Date',
    'admin.startTime': 'Start Time',
    'admin.endTime': 'End Time',
    'admin.status': 'Status',
    'admin.available': 'Available',
    'admin.booked': 'Booked',
    'admin.bookedBy': 'Booked By',
    'admin.actions': 'Actions',
    'admin.addTimeSlot': 'Add Time Slot',
    'admin.createAllSlots': 'Create All Slots',
    'admin.remove': 'Remove',
    'admin.createField': 'Create Booking Field',
    'admin.editField': 'Edit Field',
    'admin.fieldName': 'Field Name (unique)',
    'admin.fieldLabel': 'Label',
    'admin.fieldType': 'Type',
    'admin.fieldPlaceholder': 'Placeholder',
    'admin.fieldOptions': 'Options (comma-separated)',
    'admin.fieldDescription': 'Description',
    'admin.fieldRequired': 'Required Field',
    'admin.allBookings': 'All Bookings',
    'admin.patientInfo': 'Patient Information',
    'admin.name': 'Name',
    'admin.email': 'Email',
    'admin.noBookings': 'No bookings yet',
    'admin.createSlot': 'Create Slot',
    'admin.selectDate': 'Select Date',
    'admin.startTime': 'Start Time',
    'admin.endTime': 'End Time',
    'admin.recurringSlots': 'Recurring Daily Slots',
    'admin.selectDays': 'Select Days',
    'admin.startDate': 'Start Date',
    'admin.endDate': 'End Date',
    'admin.dateRange': 'Date Range',
    'admin.createRecurring': 'Create Recurring Slots',
    'admin.sunday': 'Sunday',
    'admin.monday': 'Monday',
    'admin.tuesday': 'Tuesday',
    'admin.wednesday': 'Wednesday',
    'admin.thursday': 'Thursday',
    'admin.friday': 'Friday',
    'admin.saturday': 'Saturday',
    'admin.exportCSV': 'Export CSV',
    'admin.exportExcel': 'Export Excel',
    'admin.exportPDF': 'Export PDF',
    'admin.slotDuration': 'Slot Duration',
    'admin.minutes': 'minutes',
    'admin.hour': 'hour',
    'admin.slotDurationHint': 'Time range will be split into slots of this duration',
    'admin.selectAtLeastOneDay': 'Please select at least one day',
    'admin.startTimeAndEndTimeRequired': 'Start time and end time are required',
    'admin.largeNumberOfSlots': 'This will create approximately {{count}} slots. Continue?',
    'admin.recurringSlotsCreated': 'Successfully created {{count}} recurring slots',
    'admin.viewCards': 'Cards',
    'admin.viewTable': 'Table',
    'admin.unbook': 'Unbook',
    'admin.unbookConfirm': 'Are you sure you want to unbook this booking?',
    'admin.unbookConfirmMessage': 'This will make the slot available again and cancel the booking.',
    'admin.unbookSuccess': 'Booking unbooked successfully',
    'admin.unbookError': 'Failed to unbook booking',
    'admin.configSaved': 'Configuration saved successfully',
    'admin.configSaveError': 'Failed to save configuration',
    'admin.siteAccess': 'Booking Pause',
    'admin.siteAccessDescription': 'Pause public booking while keeping admin login and management available.',
    'admin.blockSiteAccess': 'Pause public booking',
    'admin.blockSiteAccessHint': 'Visitors will see the selected message and booking actions will be paused.',
    'admin.blockReason': 'Pause reason',
    'admin.siteAccess.maintenance': 'Site under maintenance',
    'admin.siteAccess.vacation': 'Schedules unavailable',
    'admin.englishMessage': 'English message',
    'admin.arabicMessage': 'Arabic message',
    'admin.saveSiteAccess': 'Save booking pause settings',
    'admin.siteAccessSaved': 'Booking pause settings saved successfully',
    'admin.siteAccessSaveError': 'Failed to save booking pause settings',
    'admin.siteAccessVerifyError': 'The server did not keep the saved booking pause setting. Please restart the backend and try again.',
    'admin.editBooking': 'Edit Booking',
    'admin.editBookingSuccess': 'Booking updated successfully',
    'admin.editBookingError': 'Failed to update booking',
    'admin.currentBooking': 'Current Booking',
    'admin.selectNewDate': 'Select New Date',
    'admin.availableSlotsForDate': 'Available Slots for Selected Date',
    'admin.current': 'Current',
    
    // Login/Register
    'auth.login': 'Sign in to your account',
    'auth.register': 'Create your account',
    'auth.name': 'Full Name',
    'auth.email': 'Email address',
    'auth.password': 'Password',
    'auth.passwordMin': 'Password (min 6 characters)',
    'auth.signIn': 'Sign in',
    'auth.signingIn': 'Signing in...',
    'auth.createAccount': 'Create account',
    'auth.creating': 'Creating account...',
    'auth.haveAccount': 'Already have an account?',
    'auth.noAccount': "Don't have an account?",
    'auth.loginLink': 'Login',
    'auth.registerLink': 'Register',
    'admin.content': 'Site Content',
    'admin.pricing': 'Prices',
    'admin.users': 'Users',
    'admin.usersDescription': 'Create and manage accounts that can access this portal.',
    'admin.createUser': 'Create account',
    'admin.editUser': 'Edit account',
    'admin.allUsers': 'All accounts',
    'admin.noUsers': 'No accounts yet.',
    'admin.userName': 'Name',
    'admin.userEmail': 'Email',
    'admin.userPassword': 'Password',
    'admin.userRole': 'Role',
    'admin.newPassword': 'New password',
    'admin.resetPassword': 'Reset password',
    'admin.passwordReset': 'Password updated successfully',
    'admin.saveChanges': 'Save changes',
    'admin.activate': 'Activate',
    'admin.deactivate': 'Deactivate',
    'admin.active': 'Active',
    'admin.inactive': 'Inactive',
    'admin.you': 'You',
    'admin.role.super': 'Super admin',
    'admin.role.admin': 'Admin',
    'admin.role.user': 'User',
    'admin.userCreated': 'Account created successfully',
    'admin.userUpdated': 'Account updated successfully',
    'admin.userDeleted': 'Account deleted',
    'admin.userDeleteConfirm': 'Delete the account for {{name}}?',
    'admin.userSaveError': 'Failed to save the account',
    'admin.usersLoadError': 'Failed to load accounts',
    'admin.pricingDescription': 'Manage the public price list page.',
    'admin.pricingEnabled': 'Show prices page',
    'admin.pricingPdf': 'Price list PDF',
    'admin.pricingPdfDescription': 'Optional. Visitors can open it from the prices page.',
    'admin.pricingHeader': 'Page header',
    'admin.pricingHeaderDescription': 'Title and currency shown at the top of the page.',
    'admin.pricingHeading': 'Heading',
    'admin.pricingSubheading': 'Subheading',
    'admin.pricingCurrency': 'Currency label',
    'admin.pricingCategories': 'Price categories',
    'admin.pricingCategoriesDescription': 'Groups of services and their prices.',
    'admin.pricingNotes': 'Notes',
    'admin.pricingNotesDescription': 'Shown under the price tables. One note per line.',
    'admin.notesHint': 'Each line becomes a separate note.',
    'admin.categoryTitle': 'Category title',
    'admin.categoryColor': 'Accent color',
    'admin.serviceName': 'Service name',
    'admin.packageName': 'Package name',
    'admin.price': 'Price',
    'admin.discountPrice': 'After discount',
    'admin.addService': 'Add service',
    'admin.addCategory': 'Add category',
    'admin.removeCategory': 'Remove category',
    'admin.addPackage': 'Add package',
    'admin.promoSection': 'Seasonal offers',
    'admin.promoDescription': 'National Day or other limited-time packages.',
    'admin.promoEnabled': 'Show offers section',
    'admin.promoTitle': 'Offer title',
    'admin.promoSubtitle': 'Offer subtitle',
    'admin.pdfUpload': 'Upload PDF',
    'admin.pdfReplace': 'Replace PDF',
    'admin.pdfView': 'View',
    'admin.pdfNone': 'No PDF uploaded yet.',
    'admin.pdfHint': 'PDF only, up to 8MB.',
    'admin.pdfUploaded': 'PDF uploaded successfully',
    'admin.pdfDeleted': 'PDF deleted',
    'admin.pdfDeleteConfirm': 'Delete the uploaded PDF?',
    'admin.pdfUploadError': 'Failed to upload the PDF',
    'admin.pdfTypeError': 'Only PDF files are accepted',
    'admin.pdfSizeError': 'File is too large. Maximum size is 8MB.',
    'admin.pricingSaved': 'Prices saved successfully',
    'admin.pricingSaveError': 'Failed to save prices',
    'admin.pricingLoadError': 'Failed to load prices',
    'admin.pricingResetConfirm': 'Restore the default price list? Your changes to prices will be lost.',
    'admin.previewPage': 'Preview page',
    'admin.saving': 'Saving...',
    'admin.contactAccounts': 'Contact & Social Accounts',
    'admin.contactAccountsDescription': 'Phone, WhatsApp and social links shown in the footer.',
    'admin.contactPhone': 'Phone (digits only)',
    'admin.contactPhoneDisplay': 'Phone (as displayed)',
    'admin.contactEmail': 'Email',
    'admin.contactHint': 'Enter a handle (@clinic) or a full link. Leave a field empty to hide it.',
    'admin.clinicLocation': 'Clinic Location',
    'admin.clinicLocationDescription': 'Address and map link shown to visitors.',
    'admin.addressEn': 'Address (English)',
    'admin.addressAr': 'Address (Arabic)',
    'admin.mapUrl': 'Google Maps link',
    'admin.mapUrlHint': 'Paste the share link from Google Maps. Leave empty to hide the directions button.',
    'admin.contentDescription': 'Manage the text shown to visitors across the site.',
    'admin.footerHours': 'Working Hours',
    'admin.footerHoursDescription': 'These lines appear at the top of the site and in the footer.',
    'admin.footerHoursTitle': 'Heading',
    'admin.footerHoursDays': 'Working days',
    'admin.footerHoursTime': 'Working time',
    'admin.footerPreview': 'Preview',
    'admin.saveFooterHours': 'Save changes',
    'admin.resetToDefault': 'Reset to default',
    'admin.footerSaved': 'Content saved successfully',
    'admin.footerSaveError': 'Failed to save content',
    'auth.showPassword': 'Show password',
    'auth.hidePassword': 'Hide password',
    'auth.subtitle': 'Sign in to manage appointments',
    
    // Validation
    'validation.required': 'This field is required',
    'validation.email': 'Please enter a valid email address',
    'validation.name': 'Please enter your name',

    // Footer
    'footer.clinicName': 'Dr. Maram Al-Shehri Clinic',
    'footer.tagline': 'Book your appointment online, quickly and easily.',
    'footer.quickLinks': 'Quick Links',
    'footer.home': 'Book an Appointment',
    'footer.contact': 'Contact Us',
    'footer.phone': 'Phone',
    'footer.whatsapp': 'WhatsApp',
    'footer.email': 'Email',
    'footer.address': 'Address',
    'footer.addressValue': 'Riyadh, Saudi Arabia',
    'footer.hours': 'Working Hours',
    'footer.followUs': 'Follow Us',
    'footer.directions': 'Get directions',
    'footer.prices': 'Price List',
    'footer.booking': 'Book an appointment',
    'footer.quickLinksTitle': 'Quick Links',
    'nav.prices': 'Prices',
    'nav.booking': 'Booking',
    'nav.user': 'User',
    'prices.viewPdf': 'View price list (PDF)',
    'prices.heading': 'Price List',
    'prices.subheading': 'Dr. Maram Alshehri',
    'prices.loading': 'Loading prices...',
    'dashboard.loadingSlots': 'Loading available times...',
    'prices.bookNow': 'Book an appointment',
    'prices.afterDiscount': 'After discount',
    'prices.limitedOffer': 'Limited time offer',
    'prices.packagePrice': 'Package price',
    'prices.ctaPrompt': 'Ready to book your appointment?',
    'prices.unavailable': 'The price list is not available right now.',
    'prices.backToBooking': 'Back to booking',
    'footer.rights': 'All rights reserved.',

    // Site block
    'siteBlock.label': 'Booking temporarily paused',
    'siteBlock.subtitle': 'Online appointment booking will return soon.',
    'siteBlock.badge': 'Booking status',
    'siteBlock.maintenance.title': 'Site Under Maintenance',
    'siteBlock.maintenance.message': 'The site is currently under maintenance. Please check back later.',
    'siteBlock.vacation.title': 'Schedules Unavailable',
    'siteBlock.vacation.message': 'Schedules are not available currently as the doctor is on annual vacation. Please check back later.',
  },
  ar: {
    // Common
    'app.name': 'نظام حجز المستشفى',
    'app.tagline': 'حجز المواعيد بسهولة',
    'welcome': 'مرحباً',
    'logout': 'تسجيل الخروج',
    'cancel': 'إلغاء',
    'close': 'إغلاق',
    'confirm': 'تأكيد',
    'save': 'حفظ',
    'delete': 'حذف',
    'edit': 'تعديل',
    'create': 'إنشاء',
    'update': 'تحديث',
    'close': 'إغلاق',
    'loading': 'جاري التحميل...',
    
    // Navigation
    'nav.home': 'الرئيسية',
    'nav.admin': 'لوحة التحكم',
    'nav.login': 'تسجيل الدخول',
    'nav.register': 'التسجيل',
    
    // Dashboard
    'dashboard.title': 'احجز موعدك',
    'dashboard.subtitle': 'اختر التاريخ والوقت المناسب لك',
    'dashboard.calendar': 'عرض التقويم',
    'dashboard.slots': 'المواعيد المتاحة',
    'dashboard.myBookings': 'حجوزاتي',
    'dashboard.noSlots': 'لا توجد مواعيد متاحة لهذا التاريخ',
    'dashboard.noBookings': 'ليس لديك حجوزات بعد',
    'dashboard.selectDate': 'اختر التاريخ',
    'dashboard.bookNow': 'احجز الآن',
    'dashboard.guestNote': 'يمكنك الحجز كضيف، لكن تسجيل الدخول يسمح لك بإدارة حجوزاتك.',
    
    // Booking
    'booking.title': 'حجز موعد',
    'booking.subtitle': 'أكمل النموذج أدناه لتأكيد حجزك',
    'booking.date': 'التاريخ',
    'booking.time': 'الوقت',
    'booking.yourInfo': 'معلوماتك',
    'booking.fullName': 'الاسم الكامل',
    'booking.email': 'البريد الإلكتروني',
    'booking.additionalInfo': 'معلومات إضافية',
    'booking.confirm': 'تأكيد الحجز',
    'booking.booking': 'جاري الحجز...',
    'booking.success': 'تم تأكيد الحجز بنجاح!',
    'booking.successMessage': 'تم حجز موعدك بنجاح!',
    'booking.cancel': 'إلغاء الحجز',
    'booking.cancelConfirm': 'هل أنت متأكد من إلغاء هذا الحجز؟',
    'booking.details': 'تفاصيل الحجز',
    'booking.status': 'الحالة',
    'booking.status.confirmed': 'مؤكد',
    'booking.status.cancelled': 'ملغي',
    'booking.status.pending': 'قيد الانتظار',
    'booking.guest': 'حجز ضيف',
    'booking.select': 'اختر',
    'booking.loadingFields': 'جاري تحميل نموذج الحجز...',
    'booking.stillLoading': 'يرجى الانتظار، لا يزال نموذج الحجز قيد التحميل.',
    'booking.fieldsFailed': 'تعذر تحميل نموذج الحجز. يرجى تحديث الصفحة والمحاولة مرة أخرى.',
    'booking.retry': 'إعادة المحاولة',
    
    // Calendar
    'calendar.goToToday': 'الذهاب إلى اليوم',
    'calendar.available': 'متاح',
    'calendar.booked': 'محجوز',
    
    // Admin
    'admin.title': 'لوحة التحكم',
    'admin.subtitle': 'إدارة المواعيد وحقول الحجز وعرض الحجوزات',
    'admin.manageSlots': 'إدارة المواعيد',
    'admin.bookingFields': 'حقول الحجز',
    'admin.viewBookings': 'عرض الحجوزات',
    'admin.createSlot': 'إنشاء موعد واحد',
    'admin.bulkCreate': 'إنشاء مواعيد متعددة',
    'admin.allSlots': 'جميع المواعيد',
    'admin.date': 'التاريخ',
    'admin.startTime': 'وقت البداية',
    'admin.endTime': 'وقت النهاية',
    'admin.status': 'الحالة',
    'admin.available': 'متاح',
    'admin.booked': 'محجوز',
    'admin.bookedBy': 'محجوز بواسطة',
    'admin.actions': 'الإجراءات',
    'admin.addTimeSlot': 'إضافة وقت',
    'admin.createAllSlots': 'إنشاء جميع المواعيد',
    'admin.remove': 'إزالة',
    'admin.createField': 'إنشاء حقل حجز',
    'admin.editField': 'تعديل الحقل',
    'admin.fieldName': 'اسم الحقل (فريد)',
    'admin.fieldLabel': 'التسمية',
    'admin.fieldType': 'النوع',
    'admin.fieldPlaceholder': 'النص التوضيحي',
    'admin.fieldOptions': 'الخيارات (مفصولة بفواصل)',
    'admin.fieldDescription': 'الوصف',
    'admin.fieldRequired': 'حقل مطلوب',
    'admin.allBookings': 'جميع الحجوزات',
    'admin.patientInfo': 'معلومات المريض',
    'admin.name': 'الاسم',
    'admin.email': 'البريد الإلكتروني',
    'admin.noBookings': 'لا توجد حجوزات بعد',
    'admin.createSlot': 'إنشاء موعد',
    'admin.selectDate': 'اختر التاريخ',
    'admin.startTime': 'وقت البداية',
    'admin.endTime': 'وقت النهاية',
    'admin.recurringSlots': 'مواعيد يومية متكررة',
    'admin.selectDays': 'اختر الأيام',
    'admin.startDate': 'تاريخ البداية',
    'admin.endDate': 'تاريخ النهاية',
    'admin.dateRange': 'النطاق الزمني',
    'admin.createRecurring': 'إنشاء مواعيد متكررة',
    'admin.sunday': 'الأحد',
    'admin.monday': 'الإثنين',
    'admin.tuesday': 'الثلاثاء',
    'admin.wednesday': 'الأربعاء',
    'admin.thursday': 'الخميس',
    'admin.friday': 'الجمعة',
    'admin.saturday': 'السبت',
    'admin.exportCSV': 'تصدير CSV',
    'admin.exportExcel': 'تصدير Excel',
    'admin.exportPDF': 'تصدير PDF',
    'admin.slotDuration': 'مدة الموعد',
    'admin.minutes': 'دقائق',
    'admin.hour': 'ساعة',
    'admin.slotDurationHint': 'سيتم تقسيم النطاق الزمني إلى مواعيد بهذه المدة',
    'admin.selectAtLeastOneDay': 'يرجى اختيار يوم واحد على الأقل',
    'admin.startTimeAndEndTimeRequired': 'وقت البدء ووقت الانتهاء مطلوبان',
    'admin.viewCards': 'البطاقات',
    'admin.viewTable': 'الجدول',
    'admin.largeNumberOfSlots': 'سيؤدي هذا إلى إنشاء حوالي {{count}} موعد. متابعة؟',
    'admin.recurringSlotsCreated': 'تم إنشاء {{count}} مواعيد متكررة بنجاح',
    'admin.unbook': 'إلغاء الحجز',
    'admin.unbookConfirm': 'هل أنت متأكد أنك تريد إلغاء هذا الحجز؟',
    'admin.unbookConfirmMessage': 'سيؤدي هذا إلى جعل الموعد متاحاً مرة أخرى وإلغاء الحجز.',
    'admin.unbookSuccess': 'تم إلغاء الحجز بنجاح',
    'admin.unbookError': 'فشل إلغاء الحجز',
    'admin.configSaved': 'تم حفظ الإعدادات بنجاح',
    'admin.configSaveError': 'فشل في حفظ الإعدادات',
    'admin.siteAccess': 'إيقاف الحجز',
    'admin.siteAccessDescription': 'إيقاف الحجز للزوار مؤقتاً مع إبقاء تسجيل دخول الإدارة وإدارة الحجوزات متاحة.',
    'admin.blockSiteAccess': 'إيقاف الحجز مؤقتاً',
    'admin.blockSiteAccessHint': 'سيظهر للزوار التنبيه المحدد وسيتم إيقاف إجراءات الحجز مؤقتاً.',
    'admin.blockReason': 'سبب إيقاف الحجز',
    'admin.siteAccess.maintenance': 'الموقع تحت الصيانة',
    'admin.siteAccess.vacation': 'المواعيد غير متاحة',
    'admin.englishMessage': 'الرسالة بالإنجليزية',
    'admin.arabicMessage': 'الرسالة بالعربية',
    'admin.saveSiteAccess': 'حفظ إعدادات إيقاف الحجز',
    'admin.siteAccessSaved': 'تم حفظ إعدادات إيقاف الحجز بنجاح',
    'admin.siteAccessSaveError': 'فشل في حفظ إعدادات إيقاف الحجز',
    'admin.siteAccessVerifyError': 'الخادم لم يحتفظ بإعداد إيقاف الحجز بعد الحفظ. يرجى إعادة تشغيل الخادم الخلفي والمحاولة مرة أخرى.',
    'admin.editBooking': 'تعديل الحجز',
    'admin.editBookingSuccess': 'تم تحديث الحجز بنجاح',
    'admin.editBookingError': 'فشل في تحديث الحجز',
    'admin.currentBooking': 'الحجز الحالي',
    'admin.selectNewDate': 'اختر تاريخ جديد',
    'admin.availableSlotsForDate': 'المواعيد المتاحة للتاريخ المحدد',
    'admin.current': 'الحالي',
    
    // Login/Register
    'auth.login': 'تسجيل الدخول إلى حسابك',
    'auth.register': 'إنشاء حسابك',
    'auth.name': 'الاسم الكامل',
    'auth.email': 'عنوان البريد الإلكتروني',
    'auth.password': 'كلمة المرور',
    'auth.passwordMin': 'كلمة المرور (6 أحرف على الأقل)',
    'auth.signIn': 'تسجيل الدخول',
    'auth.signingIn': 'جاري تسجيل الدخول...',
    'auth.createAccount': 'إنشاء حساب',
    'auth.creating': 'جاري إنشاء الحساب...',
    'auth.haveAccount': 'لديك حساب بالفعل؟',
    'auth.noAccount': 'ليس لديك حساب؟',
    'auth.loginLink': 'تسجيل الدخول',
    'auth.registerLink': 'التسجيل',
    'admin.content': 'محتوى الموقع',
    'admin.pricing': 'الأسعار',
    'admin.users': 'المستخدمون',
    'admin.usersDescription': 'إنشاء وإدارة الحسابات التي يمكنها الدخول إلى لوحة التحكم.',
    'admin.createUser': 'إنشاء حساب',
    'admin.editUser': 'تعديل الحساب',
    'admin.allUsers': 'جميع الحسابات',
    'admin.noUsers': 'لا توجد حسابات بعد.',
    'admin.userName': 'الاسم',
    'admin.userEmail': 'البريد الإلكتروني',
    'admin.userPassword': 'كلمة المرور',
    'admin.userRole': 'الصلاحية',
    'admin.newPassword': 'كلمة المرور الجديدة',
    'admin.resetPassword': 'إعادة تعيين كلمة المرور',
    'admin.passwordReset': 'تم تحديث كلمة المرور بنجاح',
    'admin.saveChanges': 'حفظ التغييرات',
    'admin.activate': 'تفعيل',
    'admin.deactivate': 'إيقاف',
    'admin.active': 'نشط',
    'admin.inactive': 'موقوف',
    'admin.you': 'أنت',
    'admin.role.super': 'مدير عام',
    'admin.role.admin': 'مدير',
    'admin.role.user': 'مستخدم',
    'admin.userCreated': 'تم إنشاء الحساب بنجاح',
    'admin.userUpdated': 'تم تحديث الحساب بنجاح',
    'admin.userDeleted': 'تم حذف الحساب',
    'admin.userDeleteConfirm': 'هل تريد حذف حساب {{name}}؟',
    'admin.userSaveError': 'فشل حفظ الحساب',
    'admin.usersLoadError': 'فشل تحميل الحسابات',
    'admin.pricingDescription': 'إدارة صفحة قائمة الأسعار الظاهرة للزوار.',
    'admin.pricingEnabled': 'إظهار صفحة الأسعار',
    'admin.pricingPdf': 'ملف قائمة الأسعار (PDF)',
    'admin.pricingPdfDescription': 'اختياري. يمكن للزوار فتحه من صفحة الأسعار.',
    'admin.pricingHeader': 'ترويسة الصفحة',
    'admin.pricingHeaderDescription': 'العنوان والعملة الظاهرة في أعلى الصفحة.',
    'admin.pricingHeading': 'العنوان',
    'admin.pricingSubheading': 'العنوان الفرعي',
    'admin.pricingCurrency': 'رمز العملة',
    'admin.pricingCategories': 'أقسام الأسعار',
    'admin.pricingCategoriesDescription': 'مجموعات الخدمات وأسعارها.',
    'admin.pricingNotes': 'ملاحظات',
    'admin.pricingNotesDescription': 'تظهر أسفل جداول الأسعار. ملاحظة في كل سطر.',
    'admin.notesHint': 'كل سطر يظهر كملاحظة منفصلة.',
    'admin.categoryTitle': 'عنوان القسم',
    'admin.categoryColor': 'لون القسم',
    'admin.serviceName': 'اسم الخدمة',
    'admin.packageName': 'اسم الباقة',
    'admin.price': 'السعر',
    'admin.discountPrice': 'بعد الخصم',
    'admin.addService': 'إضافة خدمة',
    'admin.addCategory': 'إضافة قسم',
    'admin.removeCategory': 'حذف القسم',
    'admin.addPackage': 'إضافة باقة',
    'admin.promoSection': 'العروض الموسمية',
    'admin.promoDescription': 'عروض اليوم الوطني أو الباقات محدودة المدة.',
    'admin.promoEnabled': 'إظهار قسم العروض',
    'admin.promoTitle': 'عنوان العرض',
    'admin.promoSubtitle': 'العنوان الفرعي للعرض',
    'admin.pdfUpload': 'رفع ملف PDF',
    'admin.pdfReplace': 'استبدال الملف',
    'admin.pdfView': 'عرض',
    'admin.pdfNone': 'لم يتم رفع أي ملف بعد.',
    'admin.pdfHint': 'ملفات PDF فقط، بحد أقصى ٨ ميجابايت.',
    'admin.pdfUploaded': 'تم رفع الملف بنجاح',
    'admin.pdfDeleted': 'تم حذف الملف',
    'admin.pdfDeleteConfirm': 'هل تريد حذف الملف المرفوع؟',
    'admin.pdfUploadError': 'فشل رفع الملف',
    'admin.pdfTypeError': 'يُقبل ملفات PDF فقط',
    'admin.pdfSizeError': 'حجم الملف كبير جداً. الحد الأقصى ٨ ميجابايت.',
    'admin.pricingSaved': 'تم حفظ الأسعار بنجاح',
    'admin.pricingSaveError': 'فشل حفظ الأسعار',
    'admin.pricingLoadError': 'فشل تحميل الأسعار',
    'admin.pricingResetConfirm': 'استعادة قائمة الأسعار الافتراضية؟ سيتم فقدان تعديلاتك.',
    'admin.previewPage': 'معاينة الصفحة',
    'admin.saving': 'جاري الحفظ...',
    'admin.contactAccounts': 'حسابات التواصل',
    'admin.contactAccountsDescription': 'الهاتف والواتساب وحسابات التواصل الاجتماعي الظاهرة في التذييل.',
    'admin.contactPhone': 'رقم الهاتف (أرقام فقط)',
    'admin.contactPhoneDisplay': 'رقم الهاتف (كما يظهر)',
    'admin.contactEmail': 'البريد الإلكتروني',
    'admin.contactHint': 'أدخل المعرف (@clinic) أو الرابط كاملاً. اترك الحقل فارغاً لإخفائه.',
    'admin.clinicLocation': 'موقع العيادة',
    'admin.clinicLocationDescription': 'العنوان ورابط الخريطة الظاهران للزوار.',
    'admin.addressEn': 'العنوان (بالإنجليزية)',
    'admin.addressAr': 'العنوان (بالعربية)',
    'admin.mapUrl': 'رابط خرائط جوجل',
    'admin.mapUrlHint': 'الصق رابط المشاركة من خرائط جوجل. اتركه فارغاً لإخفاء زر الاتجاهات.',
    'admin.contentDescription': 'إدارة النصوص التي تظهر للزوار في الموقع.',
    'admin.footerHours': 'أوقات دوام الدكتورة',
    'admin.footerHoursDescription': 'تظهر هذه الأسطر في أعلى الموقع وفي التذييل.',
    'admin.footerHoursTitle': 'العنوان',
    'admin.footerHoursDays': 'أيام الدوام',
    'admin.footerHoursTime': 'وقت الدوام',
    'admin.footerPreview': 'معاينة',
    'admin.saveFooterHours': 'حفظ التغييرات',
    'admin.resetToDefault': 'استعادة الوضع الافتراضي',
    'admin.footerSaved': 'تم حفظ المحتوى بنجاح',
    'admin.footerSaveError': 'فشل حفظ المحتوى',
    'auth.showPassword': 'إظهار كلمة المرور',
    'auth.hidePassword': 'إخفاء كلمة المرور',
    'auth.subtitle': 'سجّل الدخول لإدارة المواعيد',
    
    // Validation
    'validation.required': 'هذا الحقل مطلوب',
    'validation.email': 'يرجى إدخال عنوان بريد إلكتروني صحيح',
    'validation.name': 'يرجى إدخال اسمك',

    // Footer
    'footer.clinicName': 'عيادة د. مرام الشهري',
    'footer.tagline': 'احجز موعدك إلكترونياً بكل سهولة وسرعة.',
    'footer.quickLinks': 'روابط سريعة',
    'footer.home': 'حجز موعد',
    'footer.contact': 'تواصل معنا',
    'footer.phone': 'الهاتف',
    'footer.whatsapp': 'واتساب',
    'footer.email': 'البريد الإلكتروني',
    'footer.address': 'العنوان',
    'footer.addressValue': 'الرياض، المملكة العربية السعودية',
    'footer.hours': 'ساعات العمل',
    'footer.followUs': 'تابعنا',
    'footer.directions': 'الاتجاهات على الخريطة',
    'footer.prices': 'قائمة الأسعار',
    'footer.booking': 'حجز موعد',
    'footer.quickLinksTitle': 'روابط سريعة',
    'nav.prices': 'الأسعار',
    'nav.booking': 'الحجز',
    'nav.user': 'مستخدم',
    'prices.viewPdf': 'عرض قائمة الأسعار (PDF)',
    'prices.heading': 'قائمة الأسعار',
    'prices.subheading': 'د. مرام الشهري',
    'prices.loading': 'جاري تحميل الأسعار...',
    'dashboard.loadingSlots': 'جاري تحميل المواعيد المتاحة...',
    'prices.bookNow': 'احجز موعدك',
    'prices.afterDiscount': 'بعد الخصم ٪',
    'prices.limitedOffer': 'عرض لفترة محدودة',
    'prices.packagePrice': 'سعر الباقة',
    'prices.ctaPrompt': 'جاهز لحجز موعدك؟',
    'prices.unavailable': 'قائمة الأسعار غير متاحة حالياً.',
    'prices.backToBooking': 'العودة إلى الحجز',
    'footer.rights': 'جميع الحقوق محفوظة.',

    // Site block
    'siteBlock.label': 'تم إيقاف الحجز مؤقتاً',
    'siteBlock.subtitle': 'سيعود الحجز الإلكتروني قريباً.',
    'siteBlock.badge': 'حالة الحجز',
    'siteBlock.maintenance.title': 'الموقع تحت الصيانة',
    'siteBlock.maintenance.message': 'الموقع تحت الصيانة حالياً. يرجى المحاولة لاحقاً.',
    'siteBlock.vacation.title': 'المواعيد غير متاحة',
    'siteBlock.vacation.message': 'المواعيد غير متاحة حالياً لأن الطبيبة في إجازتها السنوية. يرجى المحاولة لاحقاً.',
  }
};
